/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

var Turbolinks = require('turbolinks');
Turbolinks.start();

window.Vue = require('vue').default;

var TurbolinksAdapter = require('vue-turbolinks');
Vue.use(TurbolinksAdapter);

var VueSweetalert2 = require('vue-sweetalert2');
Vue.use(VueSweetalert2);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will crea
 * te a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let app;

let setupTokenForAxios = () => {
    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
        // console.log('token for axios is ready.');
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
};

let initVue = () => {
    return new Vue({
        el: '#vue-app'
    });
};

let initBootstrapExtra = () => {
    window.jQuery('.carousel').carousel({
        interval: 1500
    });
};

let documentReadyFunc = () => {
    setupTokenForAxios();
    app = initVue();
    initBootstrapExtra();
};

if (Turbolinks === undefined) {
    documentReadyFunc();
} else {
    document.addEventListener('turbolinks:load', documentReadyFunc);
    document.addEventListener('turbolinks:before-render', () => {
        if (app instanceof Vue) {
            app.$destroy();
        }
    });
}